<template>
  <div class="frame">
    <keep-alive>
      <router-view/>
    </keep-alive>

    <van-tabbar class="tabbar" v-model="active">
      <van-tabbar-item to="/home">
        <template slot="icon" slot-scope="props">
          <i class="iconfont icon-shouye-" v-show="!props.active"></i>
          <!-- <svg class="icon" aria-hidden="true" v-else>
            <use xlink:href="#icon-shouye2"></use>
          </svg> -->
          <img src="../assets/iconImg/home.png" v-show="props.active">
        </template>
      </van-tabbar-item>

      <van-tabbar-item to="/model">
        <template slot="icon" slot-scope="props">
          <i class="iconfont icon-moxing" v-show="!props.active"></i>
          <!-- <svg class="icon" aria-hidden="true"  v-else>
            <use xlink:href="#icon-mo1"></use>
          </svg> -->
          <img src="../assets/iconImg/model.png" v-show="props.active">
        </template>
      </van-tabbar-item>

      <van-tabbar-item to="/pavilion">
        <template slot="icon" slot-scope="props">
          <i class="iconfont icon-weibiaoti-" v-show="!props.active"></i>
          <!-- <svg class="icon aa" aria-hidden="true"  v-else>
            <use xlink:href="#icon-zhanguan2"></use>
          </svg> -->
          <img src="../assets/iconImg/pavilion.png" v-show="props.active">
        </template>
      </van-tabbar-item>

      <van-tabbar-item to="/user">
        <template slot="icon" slot-scope="props">
          <i class="iconfont icon-wode1" v-show="!props.active"></i>
          <!-- <svg class="icon" aria-hidden="true"  v-else>
            <use xlink:href="#icon-wo1"></use>
          </svg> -->
          <img src="../assets/iconImg/user.png" v-show="props.active">
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import { Tabbar, TabbarItem } from "vant";
export default {
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem
  },

  data() {
    return {
      active: 0,
      tabs: {
        '/home': 0,
        'model': 1,
        '/pavilion': 2,
        '/user': 3
      }
    };
  },

  created() {
    let currPath = this.$route.path;
    Object.keys(this.tabs).some(path => {
      if (currPath.indexOf(path) > -1) {
        this.active = this.tabs[path];
        return true;
      }
    });
  }
};
</script>

<style lang="less" scoped>
.frame {
  padding-bottom: 50px;
  // background-color: rgba(249,249,249,1);
  height: 100%;
}

.tabbar {
  background-color: #ffffff;
}
.tabbar:after {
  border-width: 0;
}
.van-tabbar-item {
  color: #abacad;
  .van-tabbar-item__icon {
    .iconfont {
      font-size: 24px;
    }
    // .icon{
      // transform: scale(0.2,0.2);
    // }
    img{
      width: 27px;
      height: auto;
    }
  }
  // /deep/.van-tabbar-item__text {
  //   font-size: 10px;
  // }
}
// .van-tabbar-item--active {
//   color: #d7b563;
// }

// .post {
//   display: inline-block;
//   width: 32px;
//   height: 32px;
//   font-size: 24px;
//   line-height: 32px;
//   text-align: center;
//   border-radius: 50%;
//   background-color: #d7b563;
//   color: #f7f7f7;
//   margin-top: -10px;
// }
</style>
